import request from '@/utils/request'

//发包方个人信息详情http://域名/issuingPartyInfo
export function issuingPartyInfo() {
  return request({
    url: '/issuingPartyInfo',
    method: 'get',
  })
}
//发包方个人信息详情 /system/informationsheet/AssetInfo
export function AssetInfoEmp() {
  return request({
    url: '/system/informationsheet/AssetInfo',
    method: 'get',
  })
}
//发包方个人信息保存http://域名/issuingPartyInfo/save
export function AssetInfoSave(data) {
  return request({
    url: '/issuingPartyInfo/save',
    method: 'post',
    data:data
  })
}
//提交企业认证信息 :
export function employerInfo(data) {
  return request({
    url: '/employerInfo',
    method: 'post',
    data:data
  })
}
//获取企业认证信息 :
export function employerInfoList() {
  return request({
    url: '/employerInfo',
    method: 'get',
  })
}
//发包方立项、发包、进行中数量 :http://域名/issuingPartyInfo/number
export function issuingPartyInfoNumber() {
  return request({
    url: '/issuingPartyInfo/number',
    method: 'get',
  })
}

//发包方账户首页我的工作任务数据统计
export function issuingPartyInfoCount() {
  return request({
    url: '/issuingPartyInfo/task/count',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/employer/user/user.js